module.exports = __webpack_public_path__ + "static/media/ico_cobertura_new.400fe299.svg";